export interface QuantitySelectorProps {
  className?: string;
  value: number;
  onIncrement: (value: unknown) => void;
  onDecrement: (value: unknown) => void;
}

export function QuantitySelector(props: QuantitySelectorProps) {
  const {
    className,
    value,
    onIncrement,
    onDecrement,
  } = props;

  return (
    <div className={`${className && className} relative`.trim()}>
      <input
        type="number"
        className="form-field-input appearance-none block px-6 py-2.5 text-center w-full"
        value={value}
      />
      <span
        className="icon-button secondary-button border-none text-russian-green-200 absolute left-2.5 bottom-0.5 focus:outline-none focus:border-russian-green-400 hover:border-russian-green-400"
        onClick={onDecrement}
        onKeyPress={onDecrement}
        role="button"
        tabIndex={0}
      >
        <i className="fa-solid fa-minus" />
      </span>
      <span
        className="icon-button secondary-button border-none text-russian-green-200 absolute right-2.5 bottom-0.5 focus:outline-none focus:border-russian-green-400 hover:border-russian-green-400"
        onClick={onIncrement}
        onKeyPress={onIncrement}
        role="button"
        tabIndex={0}
      >
        <i className="fa-solid fa-plus" />
      </span>
    </div>
  );
}
